module.exports = (__parcel__import__("bTBsv")).then(() => parcelRequire('jppWD'));